import { z } from "zod";
export const isoDateTimeSchema = z.iso.datetime();
export const isoDateOnlySchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Format YYYY-MM-DD requis");
